import React, {PropTypes} from 'react';


class RhinoSelect extends React.Component {

  static defaultProps = {
    blurMethod: () => {},
    disabled: false,
    error: false,
    value: null,
  };

  static propTypes = {
    blurMethod: PropTypes.func,
    changeMethod: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  getParentClass() {
    return this.props.error === false ? 'RhinoSelect' : 'RhinoSelect error';
  }

  render() {
    return (
      <div className={this.getParentClass()}>
        <select 
          disabled={this.props.disabled}
          onBlur={::this.props.blurMethod}
          onChange={::this.props.changeMethod}
          defaultValue={this.props.value !== null ? this.props.value : this.props.options[0].value}>
          {this.props.options.map(option => {
            return <option 
              key={option.key} 
              value={option.value}>
              {option.display}
            </option>;
          })}
        </select>
        <div className='select__arrow'></div>
      </div>
    );
  }
}
export default RhinoSelect;


// WEBPACK FOOTER //
// ./src/components/common/inputs/RhinoSelect.jsx